export default class FilterHeader extends React.Component {
  constructor (props) {
    super(props);
    this.showMap = this.showMap.bind(this);
    this.recSort = this.recSort.bind(this);
    this.priceSort = this.priceSort.bind(this);
    this.distanceSort = this.distanceSort.bind(this);
    this.reviewsSort = this.reviewsSort.bind(this);
    this.sortLineClassName = this.sortLineClassName.bind(this);
  }

  showMap() {
    this.props.showMap();
  }

  recSort() {
    this.props.showList();
    this.props.sort('recommendation', false);
  }

  priceSort () {
    const newIsDescending = this.typeMatches(this.props.sort_type, 'price') ? !this.props.descending : false;

    this.props.showList();
    this.props.sort('price', newIsDescending);
  }

  distanceSort() {
    this.props.showList();
    this.props.sort('distance');
  }

  reviewsSort() {
    this.props.showList();
    this.props.sort('reviews', false);
  }

  typeMatches(sort_type, type) {
    return sort_type === type;
  }

  rotateFlip(descending, type_matches) {
    return (descending && type_matches) ? '' : 'rotate_flip';
  }

  btnActive(active) {
    return active ? 'sort__btn_active' : '';
  }

  sortLineClassName () {
    let className = 'sort__line';
    if (!this.props.campsLoaded)
      className += ' card-loader disabling-loader';
    return className
  }

  render() {
    return (
      <div id='filter_header'>
        <div className='sort sort_wrap'
             id='sort_widget'
        >
          <div className={this.sortLineClassName()}>
            <button className={'sort__btn ' + this.btnActive(this.typeMatches(this.props.sort_type, 'recommendation'))}
                    onClick={this.recSort}
            >
              рекомендуемые
            </button>

            <button className={'sort__btn ' + this.btnActive(this.typeMatches(this.props.sort_type,'reviews'))}
                    onClick={this.reviewsSort}
            >
              по отзывам
            </button>

            <button className={'sort__btn sort__btn_ico sort__btn_ico-right ' + this.btnActive(this.typeMatches(this.props.sort_type,'price'))}
                    onClick={this.priceSort}
            >
              по цене&nbsp;
              <div className={'sort__btn-icon ' + this.rotateFlip(this.props.descending, this.typeMatches(this.props.sort_type,'price'))}>
                <div className='icon icon-list-price icon-list-price-dims'/>
              </div>
            </button>
          </div>

          <div className={this.sortLineClassName()}>
            <button className={'sort__btn sort__btn-list sort__btn_ico ' + this.btnActive(this.props.listShowMode)}
                    onClick={this.props.showList}
            >
              <div className={'sort__btn-icon'}>
                <div className='icon icon-list-ico icon-list-ico-dims'/>
              </div>
              Списком
            </button>

            <button className={'sort__btn sort__btn-map sort__btn_ico sort__btn_ico-left ' + this.btnActive(!this.props.listShowMode)}
                    onClick={ () => { this.showMap(); window.ymReachGoal('filter:tabs:map'); } }
            >
              На карте
              <div className={'sort__btn-icon'}>
                <div className='icon icon-map-ico icon-map-ico-dims'/>
              </div>
            </button>
          </div>
        </div>
        {
          this.props.dateRangeNotifierForSanatoriums ?
            <div dangerouslySetInnerHTML={{__html: this.props.dateRangeNotifierForSanatoriums }} className={'card card_big date_range_alert'} /> : ''
        }
      </div>
    );
  }
}
